<div class="px-4 gap-2 grid">
  @if (sensors()?.length === 0) {
    <!-- Empty -->
    <span class="flex justify-center rounded-2xl font-title px-5 py-4 border border-gray-200 w-full">
      <div class="bg-gray-200 h-10 w-full flex items-center justify-center rounded-lg">
        No hay sensores
      </div>
    </span>

  } @else {
    @for (group of sensorGroups(); track group.id; let i = $index) {
      <div class="flex gap-2 items-center" [class.my-2]="i !== 0" [class.mb-2]="i === 0">
        <div class="text-sm font-title font-semibold">{{ group.name?? "Sin grupo" }}</div>
        @if (group.type != sensorGroupType().NONE && group.type != null) {
          <lib-badge size="xs" variant="light" [color]="groupBadgeUi(group.type)?.color">{{groupBadgeUi(group.type)?.text}}</lib-badge>
        }
      </div>

      @for (sensor of group.items; track sensor.id) {
        <sensor-list-card class="grid" [sensor]="sensor"></sensor-list-card>
      }
    }
  }
</div>